import { FILE_SCOPE_REQUEST } from '../../../../constants/file'

export function getRequestAttachedFiles(data) {
  return { items: data.objects, parent: data.parent }
}

export function getRequestNextAttachedFiles(files, removedFiles) {
  return {
    files: files.reduce((acc, file) => {
      if (removedFiles.includes(file.id)) {
        return acc
      }

      return [...acc, file.id]
    }, []),
  }
}

export function getFilesItemsApiProps({ objectId, ordering, page, parent }) {
  return {
    object_id: objectId,
    ordering,
    page,
    parent,
    scope: FILE_SCOPE_REQUEST,
  }
}
